import Platform from '../platform';
import device   from './device';
import viewer   from './viewer';

export default {
  namespaced: true,
  modules   : {
    device,
    viewer,
  },
  state: () => ({
    platform: null,
  }),
  getters: {
    ready: (state, getters) => !!(state.platform && getters['viewer/ready']),
  },
  mutations: {
    setPlatform(state, { platform }) {
      state.platform = platform;
    },
  },
  actions: {
    initialize({ commit, dispatch }, context = {}) {
      const { platform, device = {} } = context;
      commit('setPlatform', { platform: platform || Platform.ATCOSME });
      return Promise.all([
        dispatch('device/initialize', device),
        dispatch('viewer/initialize'),
      ]);
    },
  },
};
